var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM8.5 11.3333C8.5 11.0572 8.72386 10.8333 9 10.8333H15C15.2761 10.8333 15.5 11.0572 15.5 11.3333V16C15.5 16.2761 15.2761 16.5 15 16.5H9C8.72386 16.5 8.5 16.2761 8.5 16V11.3333ZM7 11.3333C7 10.3134 7.7635 9.47174 8.75016 9.34879L8.75 9.33333V7.5C8.75 5.70507 10.2051 4.25 12 4.25C13.7949 4.25 15.25 5.70507 15.25 7.5V9.33333L15.2498 9.34879C16.2365 9.47174 17 10.3134 17 11.3333V16C17 17.1046 16.1046 18 15 18H9C7.89543 18 7 17.1046 7 16V11.3333ZM13.75 7.5V9.33333H10.25V7.5C10.25 6.5335 11.0335 5.75 12 5.75C12.9665 5.75 13.75 6.5335 13.75 7.5ZM12 15.4C12.4602 15.4 12.8333 15.012 12.8333 14.5333C12.8333 14.0547 12.4602 13.6667 12 13.6667C11.5398 13.6667 11.1667 14.0547 11.1667 14.5333C11.1667 15.012 11.5398 15.4 12 15.4Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7e979c1bac9159ab3bfb1ee69f1cb92e.svg";
export { ForwardRef as ReactComponent };